import React from 'react';
import { GridItem } from '@stockx/ui';
import { useTranslation } from 'react-i18next';
import { getPricelineData, Priceline, ProductTile } from '@app/catalog';
import { useCurrency } from '@app/currency';
import { trackEvent as segmentTrackEvent, EVENTS } from '@app/segment';
import { useGATrackEvent, Events, Categories } from '@app/analytics';
import isNil from 'lodash/isNil';

const UserGeneratedContentRelatedItems = ({ product, index }) => {
  const { t } = useTranslation();
  const { currency } = useCurrency();
  const pricelineData = getPricelineData(product, t, currency, 'lowestAsk');
  const gaTrack = useGATrackEvent();

  // Handle Segment, GA tracking
  const trackUGCRelatedProductClick = () => {
    segmentTrackEvent(EVENTS.AS_SEEN_ON_INSTAGRAM_CLICKED, {
      vertical: product?.productCategory,
      productUUID: product?.uuid,
      position: index,
      swooshName: 'As Seen on Instagram',
      skuUUID: product?.variants?.find(
        (variant) =>
          !isNil(product?.market?.bidAskData?.lowestAsk) &&
          variant?.market?.bidAskData?.lowestAsk ===
            product?.market?.bidAskData?.lowestAsk,
      )?.id,
      productName: product?.title,
      lowestAsk: pricelineData?.amount,
      hasImage: !isNil(product?.media?.smallImageUrl),
      currency,
      screenName: 'As Seen on Instagram',
    });
    gaTrack(
      Events.productTileClick,
      Categories.AsSeenOnInstagram,
      product?.uuid,
    );
  };

  return (
    <GridItem
      as="li"
      role="listitem"
      data-component="ugc-product-tile"
      key={product.uuid}
    >
      <ProductTile
        index={index}
        product={product}
        tracking={''}
        screenName={''}
        handleTrackEvent={trackUGCRelatedProductClick}
      >
        <Priceline
          arial-label={`${pricelineData.label} ${pricelineData.amount}`}
          label={pricelineData.label}
          amount={pricelineData.amount}
        />
      </ProductTile>
    </GridItem>
  );
};

export default UserGeneratedContentRelatedItems;
